module.exports = __webpack_public_path__ + "static/media/info.3941b4c9.svg";